const tableMarkerKeys = Object.freeze({
  MARKER: 'Marker',
  TEMPERATURE: 'Temperature',
  DELTA: 'ΔT',
  REFERENCE: 'Reference',
});

export default tableMarkerKeys;
